import { render, staticRenderFns } from "./Introduccion.vue?vue&type=template&id=1351835d&lang=pug"
import script from "./Introduccion.vue?vue&type=script&lang=js"
export * from "./Introduccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports